// import logo from './logo.svg';
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Header from "./Elements/header";
import HomePage from "./Pages/homePage";
import ScrollToTop from "./Elements/scroll_top";
import Footer from "./Elements/footer";
import Floorplans from "./Pages/floorplans";
import Amenities from "./Pages/amenities";
import LocalInformation from "./Pages/localInformation";
import AboutUs from "./Pages/aboutUs";
import PrivacyPolicy from "./Pages/privacyPolicy";
import TermsConditions from "./Pages/termsConditions";
import SecurityProtection from "./Elements/SecurityProtection";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SecurityProtection />
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/getintouch" element={<HomePage />} />

          <Route path="/floorplans" element={<Floorplans />} />
          <Route path="/amenities" element={<Amenities />} />
          <Route path="/local-information" element={<LocalInformation />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
